module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_02_A.c9e35535.png";